import React, { useContext, useReducer, useEffect } from 'react';
import { UserContext, reducer, initialUserData } from './reducer';
import { USER_LOGIN, USER_LOGOUT, LOADING_ON, LOADING_OFF } from './types';
import { useSessionStorage } from '@hooks';
import { handleAuth, handleUserData } from './actions';

export const useUserContext = () => useContext(UserContext);

const UserProvider = ({ children }) => {
  const [{ currentUser, isLoading }, dispatch] = useReducer(
    reducer,
    initialUserData,
  );

  const [token, setToken] = useSessionStorage('token', null);

  const onAuth = async ({ values, type }) => {
    try {
      dispatch({ type: LOADING_ON });
      const userData = await handleAuth({ values, type });
      setToken(userData.token);
      dispatch({ type: USER_LOGIN, payload: userData.user });
    } catch (e) {
      if (type === USER_LOGIN) {
        throw new Error('Login fail');
      } else {
        throw new Error('Sign Up fail');
      }
    } finally {
      dispatch({ type: LOADING_OFF });
    }
  };

  const onLogout = () => {
    dispatch({ type: LOADING_ON });
    setToken('');
    dispatch({ type: USER_LOGOUT });
    dispatch({ type: LOADING_OFF });
  };

  const getCurrentUser = async () => {
    if (token) {
      try {
        const userData = await handleUserData(token);
        dispatch({ type: USER_LOGIN, payload: userData });
      } catch {
        throw new Error('User 정보를 불러오는데 실패했습니다!');
      }
    }
  };

  useEffect(() => getCurrentUser(), []);

  return (
    <UserContext.Provider
      value={{
        currentUser,
        token,
        isLoading,
        onAuth,
        onLogout,
        getCurrentUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
